import { render, staticRenderFns } from "./ConfigCamarasStreamax.vue?vue&type=template&id=6d638b71&scoped=true&"
import script from "./ConfigCamarasStreamax.vue?vue&type=script&lang=ts&"
export * from "./ConfigCamarasStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigCamarasStreamax.vue?vue&type=style&index=0&id=6d638b71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d638b71",
  null
  
)

export default component.exports